import {
  type FetchCreatives_me_creatives_rows,
  type SalesPageMetric,
  dimensionPlatformToPlatform,
} from "@north-beam/nb-client-side";
import { CreativePlatformEnum } from "@north-beam/nb-client-side";

export function getPlatformMetricFromAd(
  ad: FetchCreatives_me_creatives_rows,
  metric: SalesPageMetric,
  metricsById: Record<string, SalesPageMetric>,
) {
  const adPlatform = dimensionPlatformToPlatform(getPlatformName(ad));
  if (!adPlatform) {
    return null;
  }

  const platformMetricId = metric?.platformEquivalent?.[adPlatform]?.id;

  if (!platformMetricId) {
    return null;
  }

  const metricSpec = metricsById[platformMetricId] as
    | SalesPageMetric
    | undefined;

  return metricSpec ?? null;
}

export function getPlatformName(ad: FetchCreatives_me_creatives_rows) {
  return ad.dimensions["Platform (Northbeam)"] as string;
}

export function getCreativeType(ad: FetchCreatives_me_creatives_rows) {
  return (
    {
      fb: CreativePlatformEnum.facebook,
      tiktok: CreativePlatformEnum.tiktok,
      snapchat: CreativePlatformEnum.snapchat,
      pinterest: CreativePlatformEnum.pinterest,
      applovin: CreativePlatformEnum.applovin,
    }[JSON.parse(ad.adKey)["platform"] as string] ||
    {
      "Google Ads": CreativePlatformEnum.adwords,
      "YouTube Ads": CreativePlatformEnum.youtube,
    }[getPlatformName(ad)]
  );
}
